export default __webpack_public_path__ + "static/media/international_program.cf20ce88.png";